import { Card, CardContent, Typography } from "@material-ui/core";
import * as classNames from "classnames";
import * as React from "react";
import { createRef } from "react";
import "./App.css";
import { AccountSum } from "./app/AccountAnalyze";
import { currencyVal } from "./app/helper";
import { Direction } from "./db/AccountMovement";
import { AccountMovement } from "./db/AccountMovement";

type SelectEvent = (movement: AccountMovement) => void;
type HoverEvent = (movement: AccountMovement | null) => void;
interface AccountProps {
  account: AccountSum;
  onHover: HoverEvent;
  onSelect: SelectEvent;
  hoverRow: AccountMovement | null;
  selectedRows: AccountMovement[];
}

export default class AccountDisplay extends React.Component<AccountProps> {
  private historyContainer = createRef<HTMLDivElement>();

  public mouseEnter = (e: React.SyntheticEvent) => {
    // this.props.onHover(this.props.account.history[+e.currentTarget.getAttribute("data-idx")!].meta.source);
  };
  public mouseLeave = (e: React.SyntheticEvent) => {
    // this.props.onHover(null);
  };
  public rowClick = (e: React.SyntheticEvent) => {
    this.props.onSelect(this.props.account.history[+e.currentTarget.getAttribute("data-idx")!].meta.source);
  };
  public scrollToBottom() {
    if (this.historyContainer.current) {
      this.historyContainer.current.scrollTop = this.historyContainer.current.scrollHeight;
    }
  }

  public componentDidMount() {
    this.scrollToBottom();
  }
  public render() {
    const a = this.props.account;

    return (
      <Card className={"account"}>
        <CardContent>
          <Typography variant="h5">{a.accountNumber}</Typography>
          <div className="accountHistory" ref={this.historyContainer}>
            <table>
              <thead>
                <tr>
                  <th className="debit">S</th>
                  <th className="credit">H</th>
                  <th className="contra" />
                  <th className="comment" />
                </tr>
              </thead>
              <tbody>
                {a.history.map((row, i) => {
                  // const label = row.meta.source.sourceFile.fileName + "\n" + row.meta.source.date.format("DD.MM.");
                  const label = "foo";
                  return (
                    <tr
                      key={i}
                      data-idx={i}
                      className={classNames({
                        primary: row.primary,
                        hover: row.meta.source === this.props.hoverRow,
                        selected: this.props.selectedRows.includes(row.meta.source)
                      })}
                      title={label}
                      onMouseEnter={this.mouseEnter}
                      onMouseLeave={this.mouseLeave}
                      onClick={this.rowClick}
                    >
                      <td className="debit">{row.side === Direction.Soll && currencyVal(row.amount)}</td>
                      <td className="credit">{row.side === Direction.Haben && currencyVal(row.amount)}</td>
                      <td className="contra">{row.primary ? row.meta.source.contraAccountNumber : row.meta.source.sourceAccountNumber}</td>
                      <td className="comment text-nowrap">
                        {/*<span className="fileName">{row.meta.source.sourceFile.fileName}</span>{" "}*/}
                        {/*<span className="lineNumber">*/}
                        {/*L<span className="lineNumberValue">{row.meta.source.lineNumber}</span>*/}
                        {/*</span>*/}
                        {/*{": "}*/}
                        <span className="rowLabel">{row.meta.source.label}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td className="debit">{a.total > 0 && currencyVal(a.total)}</td>
                  <td className="credit">{a.total < 0 && currencyVal(a.total * -1)}</td>
                  <td className="comment" />
                  <td className="comment" />
                </tr>
              </tfoot>
            </table>
          </div>
        </CardContent>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AccountDisplay.tsx